__turbopack_context__.v({
  "labelCopy": "wE7xBW_labelCopy",
  "priceLabelContainer": "wE7xBW_priceLabelContainer",
  "tooltipContentContainer": "wE7xBW_tooltipContentContainer",
  "tooltipItemContainer": "wE7xBW_tooltipItemContainer",
  "valueCopy": "wE7xBW_valueCopy",
});
